<mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>{{'importer.direction' | translate | capitalizeFirst}}</mat-label>
    <button mat-icon-button matSuffix type="button" aria-label="Clear selection" [disabled]="disabled"
        (click)="onSelectChange(null); $event.stopPropagation()">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
    <mat-select [value]="value" (selectionChange)="onSelectChange($event.value)" [disabled]="disabled" [multiple]="multiple">
        <mat-option *ngFor="let dir of filtered$ | async" [value]="dir.value">
            {{ dir.displayValue }}
        </mat-option>
    </mat-select>
</mat-form-field>